module.exports = __webpack_public_path__ + "img/safe_07.573ed260.png";